module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Podaj ",
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "placeholder": "Last Name"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill btn-wd",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfile($event)
      }
    }
  }, [_vm._v("\n          Update Profile\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Edit Profile")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac7f5a8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UserProfile/EditProfileForm.vue
// module id = 450
// module chunks = 1